/* MXDVS knitwear "How it's made" slider menu (30.09.2026)
   Used by sections/mxdvs-knit-howmade.liquid on templates/product.knitwear-in-house.json only.
   - Puts the "How it's made" dropdown in the product info, under the other dropdowns (same slide as those,
     handled by assets/mxdvs-product-lower.js), open on page load when set in the theme editor.
   - Compact row: glass porthole + needle bed strip, moved by scrolling; course counter; the link text.
   - A tap loads assets/mxdvs-knit-explainer.js (only then) and opens the explainer in the same window.
   Redraws only while the page scrolls, the dropdown is open and the embed is on screen.
   Needles ease after the scroll (one carriage sweep per 1800px by default), at most one draw per frame. */
(function () {
  if (window.MxKnit) return;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ST = { yarn: '#c8102e' };
  /* 08.10.2026 (C2): black card palette for the compact row (same drawing, only the colours changed) */
  var PAL = { port: '#0b0b0c', plate: '#2a2d30', needle: '#8a9096', hook: '#c9ccd0', yarn: '#ffffff', ink: '#ffffff', strip: '#111214', stripPlate: '#2a2d30', win: 'rgba(255,255,255,.07)', winLine: 'rgba(255,255,255,.3)' };
  var POOL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*';

  function setup(cv, w, h) {
    w = Math.max(1, Math.round(w)); h = Math.max(1, Math.round(h));
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    cv.style.width = w + 'px'; cv.style.height = h + 'px';
    var c = cv.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); return c;
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function tri(p) { p = ((p % 2) + 2) % 2; return p < 1 ? p : 2 - p; }
  function line(c, x1, y1, x2, y2, col, lw) { c.strokeStyle = col || '#16181a'; c.lineWidth = lw || 1.25; c.beginPath(); c.moveTo(x1, y1); c.lineTo(x2, y2); c.stroke(); }
  function decode(el, text) {
    clearInterval(el._d); if (RM) { el.textContent = text; return; }
    var t = 0; el._d = setInterval(function () { t++; el.textContent = text.split('').map(function (ch) { return (t >= 8 || ch === ' ') ? ch : POOL[Math.random() * POOL.length | 0]; }).join(''); if (t >= 8) clearInterval(el._d); }, 40);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function portB(c, W, H, s) {
  c.fillStyle = PAL.port; c.fillRect(0, 0, W, H);
  var p = 12, fx = tri(s * 1.6) * (W + 40) - 20, pts = [];
  for (var x = 6, i = 0; x < W; x += p, i++) {
    var d = Math.abs(x - fx), lift = d < 30 ? Math.cos(d / 30 * Math.PI / 2) : 0;
    var top = 70 - lift * 40;
    c.fillStyle = PAL.plate; c.fillRect(x - 3, 78, 6, H);
    c.strokeStyle = PAL.needle; c.lineWidth = 2; c.beginPath(); c.moveTo(x, H); c.lineTo(x, top + 4); c.stroke();
    c.beginPath(); c.arc(x - 2.5, top + 4, 2.5, 0, Math.PI, true); c.stroke();
    pts.push([x, top + 3]);
  }
  c.strokeStyle = PAL.yarn; c.lineWidth = 1.6; c.beginPath();
  pts.forEach(function (pt, k) { var y = Math.min(pt[1], 62); if (!k) c.moveTo(pt[0], y); else c.lineTo(pt[0], y); });
  c.stroke();
  c.fillStyle = PAL.ink; c.beginPath(); c.moveTo(fx - 6, 20); c.lineTo(fx + 6, 20); c.lineTo(fx, 40); c.closePath(); c.fill();
  line(c, fx, 0, fx, 20, PAL.yarn, 1.6);
}

  function stripA(c, W, H, s) {
  c.fillStyle = PAL.strip; c.fillRect(0, 0, W, H);
  var p = 8, cx = tri(s) * (W + 120) - 60, cw = 90;
  for (var x = 4, i = 0; x < W; x += p, i++) {
    c.fillStyle = PAL.stripPlate; c.fillRect(x - 1.5, 0, 3, H);
    var dist = Math.abs(x - cx), lift = dist < cw / 2 ? Math.cos(dist / (cw / 2) * Math.PI / 2) : 0;
    var sel = (i % 4 < 2) ? 1 : .55;
    var tip = 18 + lift * sel * 30;
    c.fillStyle = PAL.hook; c.fillRect(x - .75, 0, 1.5, tip);
    c.beginPath(); c.arc(x, tip, 1.8, 0, Math.PI * 2); c.fill();
    c.fillRect(x - 2, tip - 26, 4, 5);
  }
  c.fillStyle = PAL.win; c.fillRect(cx - cw / 2, 0, cw, H);
  line(c, cx - cw / 2, 0, cx - cw / 2, H, PAL.winLine, 1); line(c, cx + cw / 2, 0, cx + cw / 2, H, PAL.winLine, 1);
  // yarn from feeder into the raised hooks
  c.strokeStyle = PAL.yarn; c.lineWidth = 1.5; c.beginPath(); c.moveTo(cx, H); c.quadraticCurveTo(cx, H * .7, cx + 8, 18 + 30); c.stroke();
}

  function linkHtml(text, style) {
    var t = esc(text), n = '', i;
    switch (style) {
      case 'underline': return '<span class="mxk-lk mxk-lk--underline" data-hover>' + t + '</span>';
      case 'pill': for (i = 0; i < 7; i++) n += '<i style="--i:' + i + '"></i>'; return '<span class="mxk-lk mxk-lk--pill"><span class="mxk-nd" aria-hidden="true">' + n + '</span><span data-hover>' + t + '</span></span>';
      case 'glass': return '<span class="mxk-lk mxk-lk--glass"><span class="mxk-rec" aria-hidden="true"></span><span data-hover>' + t + '</span></span>';
      case 'thread': return '<span class="mxk-lk mxk-lk--thread"><span class="mxk-ch">' + String(text).split('').map(function (c, k) { return '<span style="--i:' + k + '">' + (c === ' ' ? '&nbsp;' : esc(c)) + '</span>'; }).join('') +
        '</span><svg class="mxk-thread" viewBox="0 0 28 14" aria-hidden="true"><path d="M0 7c6 0 7-5 12-5s5 9 10 9 4-4 6-4" fill="none" stroke="' + esc(ST.yarn) + '" stroke-width="1.5" stroke-linecap="round"/></svg></span>';
      default: return '<span class="mxk-lk mxk-lk--terminal"><span data-hover>&gt; ' + t + '</span><i class="mxk-cur" aria-hidden="true"></i></span>';
    }
  }

  function init(root) {
    if (root.dataset.mxkReady) return; root.dataset.mxkReady = '1';
    var cfg = {}; try { cfg = JSON.parse(root.querySelector('[data-mxk-json]').textContent); } catch (e) { return; }
    ST.yarn = cfg.yarn || ST.yarn;
    var det = root.querySelector('details.mxk-acc'), slot = root.querySelector('[data-mxk-slot]');
    if (!det || !slot) return;
    slot.innerHTML =
      '<button type="button" class="mxk-embed" aria-label="' + esc(cfg.linkText) + ' ' + esc(cfg.exTitle) + '">' +
        '<span class="mxk-row"><span class="mxk-port"><canvas data-draw="port"></canvas></span><span class="mxk-strip"><canvas data-draw="strip"></canvas></span></span>' +
        '<span class="mxk-meta"><span class="mxk-count"><b data-count>C 0000</b> / ' + esc(cfg.countLabel) + '</span>' + linkHtml(cfg.linkText, cfg.linkStyle) + '</span>' +
      '</button>';
    var btn = slot.querySelector('.mxk-embed'), counter = slot.querySelector('[data-count]'), hv = slot.querySelector('[data-hover]');
    var cvPort = slot.querySelector('[data-draw="port"]'), cvStrip = slot.querySelector('[data-draw="strip"]'), pc = null, sc = null, sW = 0;
    /* 08.10.2026 (A5): the letters of the link no longer scramble on hover */

    function size() {
      pc = setup(cvPort, 64, 64);
      cvStrip.style.width = '0px'; // let the CSS decide the width first
      sW = Math.max(60, cvStrip.parentNode.clientWidth);
      sc = setup(cvStrip, sW, 64);
      draw();
    }
    var pass = Math.max(100, +cfg.embPass || 1800), soft = Math.min(1, Math.max(.02, +cfg.embSoft || .1)), sCur = null, raf = null;
    function goal() { return (window.scrollY || 0) * (cfg.scrollGain || 1) / pass; }
    function draw() {
      if (!pc || !sc) return;
      if (sCur == null) sCur = goal();
      var y = window.scrollY || 0, s = sCur;
      pc.clearRect(0, 0, 64, 64); pc.save(); pc.scale(64 / 112, 64 / 112); portB(pc, 112, 112, s); pc.restore();
      sc.clearRect(0, 0, sW, 64); stripA(sc, sW, 64, s);
      counter.textContent = 'C ' + ('000' + Math.floor(y * (cfg.scrollGain || 1) / 12)).slice(-4);
    }
    function loop() { // eases toward the scroll position, stops once it has caught up
      raf = null;
      var g = goal(); sCur = sCur == null ? g : sCur + (g - sCur) * (RM ? 1 : soft);
      if (Math.abs(g - sCur) < .0005) sCur = g; else raf = requestAnimationFrame(loop);
      draw();
    }
    window.addEventListener('scroll', function () {
      if (!det.open) return;
      var r = btn.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) { sCur = null; return; } // off screen: nothing to draw
      if (!raf) raf = requestAnimationFrame(loop);                              // at most one draw per frame
    }, { passive: true });
    if ('ResizeObserver' in window) { var lastW = 0; new ResizeObserver(function () { var w = btn.clientWidth; if (w && w !== lastW) { lastW = w; size(); } }).observe(btn); }

    /* Open the explainer: its script is only downloaded now */
    var loading = false;
    btn.addEventListener('click', function () {
      if (window.MxKnitEx) { window.MxKnitEx.open(cfg); return; }
      if (loading) return; loading = true; btn.setAttribute('aria-busy', 'true');
      var s = document.createElement('script'); s.src = cfg.explainer; s.async = true;
      s.onload = function () { loading = false; btn.removeAttribute('aria-busy'); if (window.MxKnitEx) window.MxKnitEx.open(cfg); };
      s.onerror = function () { loading = false; btn.removeAttribute('aria-busy'); };
      document.head.appendChild(s);
    });
    if (location.hash === '#how-its-made') history.replaceState(null, '', location.pathname + location.search);

    /* Put the dropdown in the product info right under Product details (09.10.2026: order Product details, How it's made,
       Included, washing tile, Shipping and returns); keep it there when the product page redraws */
    function place() {
      var view = document.querySelector('[data-mxp-view]'); if (!view) return false;
      var first = view.querySelector('details.pp-acc[data-acc="details"]');
      var accs = view.querySelectorAll('details.pp-acc:not(.mxk-acc)'), last = first || accs[accs.length - 1];
      if (last) { if (last.nextElementSibling !== det) last.insertAdjacentElement('afterend', det); return true; }
      var info = view.querySelector('.pp-info'); if (info && det.parentNode !== info) info.appendChild(det);
      return !!info;
    }
    var tries = 0, mo = null;
    (function wait() {
      if (place()) {
        var view = document.querySelector('[data-mxp-view]'), pend = false;
        mo = new MutationObserver(function (ms) { if (pend || ms.every(function (m) { return det.contains(m.target); })) return; pend = true; requestAnimationFrame(function () { pend = false; place(); }); });
        mo.observe(view, { childList: true, subtree: true });
        size();
        return;
      }
      if (++tries < 50) setTimeout(wait, 100); else size(); // no MXDVS product section on this page: stays where the section is
    })();
  }

  function boot() { document.querySelectorAll('[data-mxk]').forEach(init); }
  window.MxKnit = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
